"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyIndicationChannel = void 0;
const topic_1 = require("../../topic");
const LOYALTY_INDICATION_CHANNEL = 'loyaltyIndication';
class LoyaltyIndicationChannel {
    constructor(_logger) {
        this._logger = _logger;
        this.channel = LOYALTY_INDICATION_CHANNEL;
        this.topics = {
            INIT_LOYALTY_INDICATION: new topic_1.Topic('INIT_LOYALTY_INDICATION', LOYALTY_INDICATION_CHANNEL, this._logger)
        };
    }
}
exports.LoyaltyIndicationChannel = LoyaltyIndicationChannel;
//# sourceMappingURL=loyalty-indication.channel.js.map